import { ReactNode } from 'react'
import { Box } from '@mui/material'
import Head from 'next/head'
import Div100vh from 'react-div-100vh'

function NoHeaderFooterLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <Head>
        <title>The SilverLogic | Custom Software Development</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Div100vh>
        <Box component="div">{children}</Box>
      </Div100vh>
    </>
  )
}

export default NoHeaderFooterLayout
